import src from "IMAGE";
export default { src, width: 397, height: 516, blurWidth: 6, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAYAAADaxo44AAAAG0lEQVR42tXJIQEAAAACIIb4f6cLHGAgARmeogYGBUFyHbDrAAAAAElFTkSuQmCC"};
